import { render, staticRenderFns } from "./listaEvaluacionesDocente_2.vue?vue&type=template&id=9cc552d8&scoped=true"
import script from "./listaEvaluacionesDocente_2.vue?vue&type=script&lang=js"
export * from "./listaEvaluacionesDocente_2.vue?vue&type=script&lang=js"
import style0 from "./listaEvaluacionesDocente_2.vue?vue&type=style&index=0&id=9cc552d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc552d8",
  null
  
)

export default component.exports